import { render, staticRenderFns } from "./addReservationComponent.vue?vue&type=template&id=6fa11d58&"
import script from "./addReservationComponent.vue?vue&type=script&lang=js&"
export * from "./addReservationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports